import React from 'react';
import { useTranslation } from 'react-i18next';
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';
import SellOutlinedIcon from '@mui/icons-material/SellOutlined';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import AspectRatioOutlinedIcon from '@mui/icons-material/AspectRatioOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined';
import { useSelector } from 'react-redux';

import SlideButton from '../../../id8/components/frames/slide-button/SlideButton';
import CommonMenu from '../../../components/common-menu/CommonMenu';
import CommonPopper from '../../../components/common-popper/CommonPopper';
import { COMMON_POPPER_MODIFIERS } from '../../../constants/popper';
import { USER_ROLES } from '../../../constants';

function MoreActions({
  onDisplay,
  onEditTags,
  onPublicLinks,
  onDelete,
  onRestore,
  popperZIndex,
  disablePortal = false,
}) {
  const { t } = useTranslation('activ8');
  const userStatus = useSelector((state) => state.securityNew.userStatus);
  const isAdmin = userStatus.includes(USER_ROLES.GLOBAL_ADMIN);

  const menuOptions = [
    ...(onDisplay
      ? [
          {
            label: t('display'),
            value: 'display',
            onClick: onDisplay,
            icon: <AspectRatioOutlinedIcon fontSize='small' />,
            preventWrap: true,
            disabled: !onDisplay,
          },
        ]
      : []),
    ...(onEditTags
      ? [
          {
            label: t('editTags'),
            value: 'editTags',
            onClick: onEditTags,
            icon: <SellOutlinedIcon fontSize='small' />,
            preventWrap: true,
            disabled: !onEditTags,
          },
        ]
      : []),
    ...(isAdmin && onPublicLinks
      ? [
          {
            label: t('publicLinks'),
            value: 'publicLinks',
            onClick: onPublicLinks,
            icon: <LinkOutlinedIcon fontSize='small' />,
            preventWrap: true,
            disabled: !onPublicLinks,
          },
        ]
      : []),
    ...(onRestore
      ? [
          {
            label: t('restore'),
            value: 'restore',
            onClick: onRestore,
            icon: <ReplayOutlinedIcon fontSize='small' />,
            preventWrap: true,
            disabled: !onRestore,
          },
        ]
      : []),
    ...(onDelete
      ? [
          {
            label: t('remove'),
            value: 'remove',
            onClick: onDelete,
            icon: <DeleteOutlinedIcon fontSize='small' />,
            isDanger: true,
            preventWrap: true,
            disabled: !onDelete,
          },
        ]
      : []),
  ];

  const handleSelect = (selectedItem) => {
    selectedItem?.onClick?.();
  };

  if (!onDisplay && !onEditTags && !onPublicLinks && !onDelete && !onRestore) {
    return null;
  }

  return (
    <CommonPopper
      zIndex={popperZIndex}
      isShowCaret={false}
      disablePortal={disablePortal}
      options={[{ ...COMMON_POPPER_MODIFIERS, name: 'offset', options: { offset: [0, 2] } }]}
      placement='bottom-end'
      component={() => <CommonMenu options={menuOptions} onSelect={handleSelect} />}>
      <SlideButton icon={MoreVertOutlinedIcon} tooltip={t('moreActions', { defaultValue: 'More actions' })} />
    </CommonPopper>
  );
}

export default MoreActions;
